import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import InvestorsListView from './Investors';
import InvestorDetail from './InvertorDetail';
import InvestmentDetailView from '../investment/InvertmentDetail';
import AgentsListView from './Agents';
import AgentDetail from './AgentDetail';
import InvestmentListView from '../investment/Investments/InvestmentListView';

const InvestorsView = () => (
  <Routes>
    <Route path="list" element={<InvestorsListView />} />
    <Route path="agents" element={<AgentsListView />} />
    <Route path="detail/:id/*" element={<InvestorDetail />} />
    <Route path="detail/:id" element={<InvestorDetail />} />
    <Route path="investments" element={<InvestmentListView />} />
    <Route path="investment/:id/*" element={<InvestmentDetailView />} />
    <Route path="investment/:id" element={<InvestmentDetailView />} />
    <Route path="agents/detail/:id/*" element={<AgentDetail />} />
    <Route path="agents/detail/:id" element={<AgentDetail />} />
    <Route index element={<Navigate to="list" replace />} />
  </Routes>
);

export default InvestorsView;
